import React, { useState } from 'react';
import NoData from '../../../global/ui/NoData';
import { emptyFunction } from '../../../utils';
import FullViewImage from '../../../components/modal/fullViewImage';

const ICONS: any = {
    download: (
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
            <polyline points="7 10 12 15 17 10" />
            <line x1="12" y1="15" x2="12" y2="3" />
        </svg>
    ),
    share: (
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <line x1="7" y1="17" x2="17" y2="7" />
            <polyline points="8 7 17 7 17 16" />
        </svg>
    ),
    edit: (
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
            <path d="M18.5 2.5a2.12 2.12 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
        </svg>
    ),
    upload: (
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M4 14.9A5 5 0 0 1 6 5.3a6 6 0 0 1 11.3 2A4.5 4.5 0 0 1 19 16" />
            <polyline points="12 12 16 16 12 20" />
            <line x1="12" y1="12" x2="12" y2="12" transform="translate(0,0)" />
            <path d="M12 12v8" />
            <polyline points="9 15 12 12 15 15" />
        </svg>
    ),
    delete: (
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="3 6 5 6 21 6" />
            <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
            <path d="M10 11v6" /><path d="M14 11v6" />
            <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" />
        </svg>
    ),
};

const AuditTimeline = ({ entries = [], emptyText = 'No activity yet.' }) => {

    const [selectedImg, setSelectedImg] = useState(null)

    if (entries?.length === 0) {
        return <NoData />;
    }

    return (
        <div className="at-list">
            {entries.map((entry: any, i: any) => (
                <div className={`at-item${i === entries?.length - 1 ? ' at-item--last' : ''}`} key={entry?.id}>
                    <span className={`at-item__icon at-item__icon--${entry?.actionType}`}>
                        {ICONS[entry?.actionType] || ICONS.edit}
                    </span>

                    <div className="at-item__body">
                        <p className="at-item__heading">
                            {entry?.timestamp} &ndash; {entry?.user} &bull; {entry?.role}
                        </p>
                        <p className="at-item__desc">{entry?.description}</p>
                        {entry?.extra_data?.location?.name && <p className="at-item__notes">{`Location: ${entry?.extra_data?.location?.name}`}</p>}
                        {entry?.notes && <p className="at-item__notes">{`Notes: ${entry?.notes}`}</p>}
                        {entry?.extra_data?.actor_role && <p className="at-item__notes">{`Permissions: Action performed by ${entry?.extra_data?.actor_role}`}</p>}
                        {entry?.extra_data?.image_url &&
                            <button className="at-item__link" onClick={() => setSelectedImg(entry?.extra_data?.image_url)}>
                                View action
                                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                    <line x1="7" y1="17" x2="17" y2="7" /><polyline points="8 7 17 7 17 16" />
                                </svg>
                            </button>
                        }
                    </div>
                </div>
            ))}
            {selectedImg &&
                <FullViewImage
                    show={selectedImg ? true : false}
                    closePopup={() => setSelectedImg(null)}
                    enlargeImage={selectedImg}
                />
            }
        </div>
    );
};

export default AuditTimeline;